export class TonsDashboardMainCtrl {
    constructor (CompanyStore, $state) {
        "ngInject";
        this.store = CompanyStore;
        this.store.init();
        this.store.refresh().then(() => {
            if ($state.current.name === 'r.in.top.tonsDashboard') {
                $state.go('r.in.top.tonsDashboard.plant', {
                    companyId: this.store.list[0].id,
                });
            }
        });
    }
}
export class TonsDashboardPlantCtrl {
    constructor (R, $stateParams) {
        "ngInject";
        this.companyId = $stateParams.companyId;
        this.R = R;
        this.years = [];
        for (let i=0; i<7; i++) {
            this.years.push(String(new Date().getFullYear()-6+i));
        }
        this.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        this.tonsData = [];
        this.tonsMonthlyProgressData = [];
        this.totals = new Array(7);
        this.currentYear = new Date().getFullYear();
        this.currentScore = null;
        this.highScore = null;
        this.scoreBeaten = false;
        this.chartData = {};
        this.fetchTons();
    }

    processTons(value) {
        let yearDict = {};
        let yearTotalsDict = {};
        let monthlyRecordsDict = {};
        let bestYearScore = 0;

        for (let year in this.years) {
            yearTotalsDict[this.years[year]] = 0;
        }
        for (let key in value) {
            if (!value[key] || !value[key].year) {
                continue;
            }
            let year = value[key].year;
            let month = value[key].month-1;
            if (!yearDict[year]) {
                yearDict[year] = new Array(12);
            }
            yearDict[year][month] = value[key].quantity;
            yearTotalsDict[year] += value[key].quantity;
            if (!monthlyRecordsDict[month] || value[key].quantity > monthlyRecordsDict[month].value) {
                monthlyRecordsDict[month] = {
                    value: value[key].quantity,
                    year: year,
                }
            }
            if (!monthlyRecordsDict[month].all) {
                monthlyRecordsDict[month].all = new Array(7);
                monthlyRecordsDict[month].all.fill(0);
            }
            let yearId = year-(new Date().getFullYear()-6);
            monthlyRecordsDict[month].all[yearId] = value[key].quantity;
            if (yearTotalsDict[year] > bestYearScore) {
                bestYearScore = yearTotalsDict[year];
            }
        }

        for (let i = 0; i < 12; i++) {
          if (!monthlyRecordsDict[i]) {
            const placeholder = {
              value: 0,
              year: this.currentYear,
              all: new Array(7).fill(0),
            };
            Object.assign(monthlyRecordsDict, { [i]: placeholder });
          }
        }

        let averages = [];

        for (let month in monthlyRecordsDict) {
            let values = monthlyRecordsDict[month].all.slice(0, 6);
            let averageFunc = (array) => array.reduce((a, b) => a + b) / array.length;
            averages.push(Math.floor(averageFunc(values)));
        }

        let tonsData = [];

        for (let i=0; i<12; i++) {
            for (let year in yearDict) {
                if (!tonsData[i]) {
                    tonsData[i] = {
                        data: new Array(7).fill(0),
                        displayData: new Array(7).fill(0),
                        monthName: this.months[i],
                    };
                }
                let yearId = year-(new Date().getFullYear()-6);
                tonsData[i].data[yearId] = yearDict[year][i] || 0;
                tonsData[i].displayData[yearId] = Math.floor(yearDict[year][i] || 0);
            }
        }

        let tonsMonthlyProgressData = [];
        for (let i=0; i<12; i++) {
            let currentScore = tonsData[i].data[6];
            let highScore = monthlyRecordsDict[i].value;
            tonsMonthlyProgressData[i] = {
                currentScore: Math.floor(currentScore),
                highScore: Math.floor(highScore),
                date: this.months[i] + ' ' + monthlyRecordsDict[i].year,
                currentDate: this.months[i] + ' ' + new Date().getFullYear(),
                scoreBeaten: currentScore >= highScore,
            };
            tonsMonthlyProgressData[i].barStyle = {
                width: Math.floor(Math.min(currentScore*100/highScore, 100) ) + '%',
            };
        }
        let thisYear = [];
        for (let month in tonsData) {
            thisYear.push(Math.floor(tonsData[month].data[6]));
        }
        this.tonsMonthlyProgressData = tonsMonthlyProgressData;
        this.tonsData = tonsData;
        this.totals = Object.keys(yearTotalsDict).map((key) => Math.floor(yearTotalsDict[key]));
        this.currentScore = Math.floor(yearTotalsDict[new Date().getFullYear()]);
        this.highScore = Math.floor(bestYearScore);
        if (this.currentScore >= this.highScore) {
            this.scoreBeaten = true;
        }
        this.barStyle = {
            width: Math.floor(Math.min(this.currentScore*100/this.highScore, 100)) + '%',
        };
        this.chartData = {
            // Chart.js data structure goes here
            // e.g. Pie Chart Data Structure http://www.chartjs.org/docs/#doughnut-pie-chart-data-structure
            labels: this.months,
            datasets: [
                {
                    data: averages,
                    backgroundColor: [
                        "#6FB6F3",
                        "#6FB6F3",
                        "#6FB6F3",
                        "#6FB6F3",
                        "#6FB6F3",
                        "#6FB6F3",
                        "#6FB6F3",
                        "#6FB6F3",
                        "#6FB6F3",
                        "#6FB6F3",
                        "#6FB6F3",
                        "#6FB6F3",
                    ],
                    label: 'Past 6 years average'
                },
                {
                    data: thisYear,
                    backgroundColor: [
                        "#F2AC6F",
                        "#F2AC6F",
                        "#F2AC6F",
                        "#F2AC6F",
                        "#F2AC6F",
                        "#F2AC6F",
                        "#F2AC6F",
                        "#F2AC6F",
                        "#F2AC6F",
                        "#F2AC6F",
                        "#F2AC6F",
                        "#F2AC6F",
                    ],
                    label: this.currentYear,
                }
            ]
        };
    }

    fetchTons() {
        let params = {
            company: this.companyId,
        };
        let tons = this.R.all('tons').customGET('', params);
        tons.then((value) => this.processTons(value));
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/tons/ctrls.js